export default __webpack_public_path__ + "static/media/liveTest.d904df26.svg";